module.exports = __webpack_public_path__ + "img/belgium-tuberculosis-female.616304c9.png";